import {request} from "@/network/request";

export function DelVenueById(id) {
  return request({
    url: 'venue/DelVenueById',
    params: {
      id
    }
  })
}

export function getVenueList(years, months, days) {
  return request({
    url: 'venue/VenueList',
    params: {
      years, months, days
    }
  })
}

export function AddVenue(vname, cid, title, tId, tName, tGender, location,lat,lng, notice, maxp, start, open, close, dates) {
  return request({
    url: 'venue/AddVenue',
    params: {
      vname, cid, title, tId, tName, tGender, location,lat,lng, notice, maxp, start, open, close, dates
    }
  })
}

export function ViewVenueQrCode(vid, clear) {
  return request({
    url: 'venue/ViewQrCode',
    params: {
      vid, clear
    }
  })
}

export function SelectVenue(vid) {
  return request({
    url: 'student/SelectVenue',
    params: {
      vid
    }
  })
}

export function CancelVunueBooking(id) {
  return request({
    url: 'student/CancelVunueBooking',
    params: {
      id
    }
  })
}

export function ScanVenueQrCode(vid, code) {
  return request({
    url: 'venue/ViewScanQrCode',
    params: {
      vid, code
    }
  })
}

export function GetVenueCountById(vid) {
  return request({
    url: 'venue/GetVenueCountById',
    params: {
      vid
    }
  })
}
export function GetVenueCalendarList() {
  return request({
    url: 'venue/GetVenueCalendarList',
  })
}
